import React, { useEffect, useState, useCallback, Component } from 'react';
import { Link } from 'react-router-dom';
import useUserStore from '../../stores/Users';

// Component
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';

// API
import { baseAPI } from '../../services/baseAPI';
import axios from 'axios';


function Home() {

  // Roles
  const ADMIN = 1;
  const EMPLOYEE = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [resume, setResume] = useState([]);
  const [isLoading, setIsLoading] = useState();


  // CONTROLLER & LOAD DATA
  const fetchResume = async () => {
    await axios
      .all(
        [
        baseAPI .get(`/v1/resumebiaya/${user.id}`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const dataResume = res[0].data.data;
        setResume(dataResume);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  useEffect(() => {
    setIsLoading(true);
    fetchResume();
  }, [token]);

  // VIEW

  const homeView = () => (
    <>
      <div className='row row-deck row-cards'>     
        {/* Simpanan pokok + wajib */}
        <div className='col-md-3'>
          <div className='card' style={{backgroundColor: '#CD5C08', borderColor: '#CD5C08'}}>
            <div className='card-body'>
              <div className='row'>
                <p style={{fontSize: 30, color:'#fff'}}>Rp.{parseFloat(resume.simpanan).toLocaleString('id-ID')}</p>
              </div>
            </div>
            <div class="card-footer bg-transparent" style={{borderColor:'#fff'}}>
              <p style={{fontWeight:'bold', fontSize: 20, marginBottom: 10, color:'#fff'}}>Simpanan Pokok + Wajib + Sukarela</p>
            </div>
          </div>
        </div>

        {/* Tabungan Berjangka */}
        <div className='col-md-3'>
          <div className='card' style={{backgroundColor: '#CD5C08', borderColor: '#CD5C08'}}>
            <div className='card-body'>
              <div className='row'>
                <p style={{fontSize: 30, color:'#fff'}}>Rp.{parseFloat(resume.tabungan).toLocaleString('id-ID')}</p>
              </div>
            </div>
            <div class="card-footer bg-transparent" style={{borderColor:'#fff'}}>
              <p style={{fontWeight:'bold', fontSize: 20, marginBottom: 10, color:'#fff'}}>Saldo Tabungan Berjangka</p>
            </div>
          </div>
        </div>

        {/* Perkiraan SHU */}
        <div className='col-md-3'>
          <div className='card' style={{backgroundColor: '#CD5C08', borderColor: '#CD5C08'}}>
            <div className='card-body'>
              <div className='row'>
                <p style={{fontSize: 30, color:'#fff'}}>Rp.{parseFloat(resume.pinjam_barang).toLocaleString('id-ID')}</p>
              </div>
            </div>
            <div class="card-footer bg-transparent" style={{borderColor:'#fff'}}>
              <p style={{fontWeight:'bold', fontSize: 20, marginBottom: 10, color:'#fff'}}>Sisa Pengangsuran Barang</p>
            </div>
          </div>
        </div>

        {/* Sisa pokok pinjaman */}
        <div className='col-md-3'>
          <div className='card' style={{backgroundColor: '#CD5C08', borderColor: '#CD5C08'}}>
            <div className='card-body'>
              <div className='row'>
                <p style={{fontSize: 30, color:'#fff'}}>Rp.{parseFloat(resume.pinjam_tunai).toLocaleString('id-ID')}</p>
              </div>
            </div>
            <div class="card-footer bg-transparent" style={{borderColor:'#fff'}}>
              <p style={{fontWeight:'bold', fontSize: 20, marginBottom: 10, color:'#fff'}}>Sisa Pokok Pinjaman Tunai</p>
            </div>
          </div>
        </div>

      </div>
    </>
  )

  return (
    <div className='container-fluid'>
      <div className='page-header'>
        <div className='row align-items-center'>
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='/' style={{ color: '#333' }}>Home</Link>
              </li>
            </ol>
          </div>
        </div>
      </div>
      {/* content */}
      <div>
        <p><b style={{fontSize: 30}}>Hi Welcome, {user.name}</b></p>
      </div>
      {isLoading ? <LoadingView /> : homeView()}
    </div>

  );
}

export default Home;